export enum OddsFormat {
    Decimal = "decimal",
    Fractional = "fractional",
    American = "american",
    HongKong = "hongKong",
    Malaysian = "malaysian",
    Indonesian = "indonesian"
}
